import './App.css';
import Layout from './components/Layout/layout'

function App() {
  return (
    <div className="App">
      <Layout />
    </div>
  );
}

export default App;
